import type { Operator } from "./index.js"

// Relationship-path operators. Their SQL depends on the path, so Postgres's
// filter_condition_sql builds it per relationship.

export const isType: Operator = {
  key: "isType",
  label: "is type",
  icon: "shapes",
  value: "scalar",
  fn: (a, b) => {
    const arr = Array.isArray(a) ? a : [a]
    return arr.some((v) => (v as { type?: unknown })?.type === b)
  },
}

// Reverse link: the current record is the target of a link from a record with
// this schema. Postgres builds it on the reverse_links path.
export const hasSchema: Operator = {
  key: "hasSchema",
  label: "for schema",
  icon: "sitemap",
  value: "scalar",
  fn: () => false, // Server-side only — no client-side evaluation
}

// The relation reaches a record listed in one of these lists (value: list ids).
// Postgres builds it on the list-relation path. Client-side it
// reads each related record's `listings`, so it holds only where those were
// fetched — a host offers it where the server evaluates the filter.
export const listedIn: Operator = {
  key: "listedIn",
  label: "is listed in",
  icon: "list",
  value: "array",
  fn: (a, b) => {
    const listIds = new Set((Array.isArray(b) ? b : [b]).map(Number))
    const related = Array.isArray(a) ? a : a == null ? [] : [a]
    return related.some((rec) =>
      ((rec as { listings?: { list_id?: unknown }[] })?.listings ?? []).some((l) =>
        listIds.has(Number(l.list_id))
      )
    )
  },
}
